import React from "react";

// @ts-ignore
import {Link} from "react-router-dom";

import './BpsStyles.css'
import Images from "../../assets/images/Images";
import Colors from "../../assets/colors/Colors";

import styled from "styled-components";
import BackComponentWrapper from "../RankingsAndLevelsComponent/Components/BackComponentWrapper";
import Constants from "../../data/Constants";

// @ts-ignore
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props {
    bkgColor: string,
    bkgImg: string
}

const BpsContainerDiv = styled.div`
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;

    background-color: ${(props: Props) => props.bkgColor};
    background-image: url(${(props: Props) => props.bkgImg});

    .bps-menu {
      flex: 1 0 auto;
      margin-top: 100px;
      margin-left: 25%;
      margin-right: 25%;
      color: #737373;

      & .bps-menu__title {
        font-family: DMSans-Bold;
        font-size: 5rem;
        line-height: 4.375rem;
        padding-bottom: 50px;
        width: 70%;
      }

      & .bps-menu__description {
        font-family: DMSans-Light;
        font-size: 1.4375rem;
        width: 70%;
      }

      & .bps-menu__buttons {
        margin-top: 50px;
      }
    }
`;

const BpsComponent: React.FC = () => {
    return (
        <BpsContainerDiv
            bkgColor={Colors.backgroundWhite}
            bkgImg={Images.mapBackgroundNoLife}
        >
            <BackComponentWrapper backColor='#737373' />
            <BpsContent />
        </BpsContainerDiv>
    )
};

const BpsContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='bps-menu'>
      <div className='bps-menu__title'>
        { t('bps.title') }
      </div>
      <div className='bps-menu__description'>
        { t('bps.description') }
      </div>
      <div className='bps-menu__buttons' style={{display: 'flex', flexDirection: 'row'}}>
        <Link className='button-component' to={Constants.routes.bpsRegions}>
          { t('bps.regions1') }
        </Link>
        <Link className='button-component' to={Constants.routes.bpsMarket}>
          { t('bps.regions2') }
        </Link>
      </div>
    </div>
  )
};

export default BpsComponent;
